export const BRAND_SIZE = 3;
export const MAX_TITLE_LENGTH = 70;
export const MAX_TITLE_LENGTH_WITHOUT_BRAND =
  MAX_TITLE_LENGTH - (process.env.NEXT_PUBLIC_BRAND?.length ?? 0) - BRAND_SIZE;
